var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "tabArrivalInformation" } }, [
    _c("div", { staticStyle: { width: "fit-content" } }, [
      _c("div", { staticStyle: { display: "flex" } }, [
        _c(
          "div",
          { staticClass: "section form-column" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  "label-width": "150px",
                  "label-position": "right",
                  disabled: _vm.readonly
                }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.PodPortInfo")))
                ]),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("SeaExport.EstimatedArrivalTime") }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "1",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedArrivalTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "estimatedArrivalTime", $$v)
                        },
                        expression: "form.estimatedArrivalTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.ArrivalTime") } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "2",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.actualArrivalTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "actualArrivalTime", $$v)
                        },
                        expression: "form.actualArrivalTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SeaExport.EstimatedPortDischargeTime")
                    }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "3",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedPortDischargeTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "estimatedPortDischargeTime", $$v)
                        },
                        expression: "form.estimatedPortDischargeTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.PortDischargeTime") } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "4",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.portDischargeTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "portDischargeTime", $$v)
                        },
                        expression: "form.portDischargeTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SeaExport.EstimatedRailwayDepartureTime")
                    }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "estimatedRailwayDepartureTime",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedRailwayDepartureTime,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "estimatedRailwayDepartureTime",
                            $$v
                          )
                        },
                        expression: "form.estimatedRailwayDepartureTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("SeaExport.RailwayDepartureTime") }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "5",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.railwayDepartureTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "railwayDepartureTime", $$v)
                        },
                        expression: "form.railwayDepartureTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SeaExport.EstimatedRailwayDischargeTime")
                    }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "6",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedRailwayDischargeTime,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "estimatedRailwayDischargeTime",
                            $$v
                          )
                        },
                        expression: "form.estimatedRailwayDischargeTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("SeaExport.RailwayDischargeTime") }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "7",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.railwayDischargeTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "railwayDischargeTime", $$v)
                        },
                        expression: "form.railwayDischargeTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "SeaExport.EstimatedTimeOfArrivalAtThePlaceOfDelivery"
                      )
                    }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "8",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedArrivalPlaceOfDelivery,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "estimatedArrivalPlaceOfDelivery",
                            $$v
                          )
                        },
                        expression: "form.estimatedArrivalPlaceOfDelivery"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "SeaExport.TheActualTimeOfArrivalAtThePlaceOfDelivery"
                      )
                    }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "9",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.actualArrivalPlaceOfDelivery,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "actualArrivalPlaceOfDelivery",
                            $$v
                          )
                        },
                        expression: "form.actualArrivalPlaceOfDelivery"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SeaExport.EstimatedCustomsReleaseTime")
                    }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "10",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedCustomsReleaseTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "estimatedCustomsReleaseTime", $$v)
                        },
                        expression: "form.estimatedCustomsReleaseTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SeaExport.ActualCustomsReleaseTime")
                    }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "11",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.destPortCustomsClearanceTime,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "destPortCustomsClearanceTime",
                            $$v
                          )
                        },
                        expression: "form.destPortCustomsClearanceTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      title: _vm.$t("SeaExport.PickupMessage"),
                      label: _vm.$t("SeaExport.EstimatedPickupTime")
                    }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "12",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedPickUpTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "estimatedPickUpTime", $$v)
                        },
                        expression: "form.estimatedPickUpTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      title: _vm.$t("SeaExport.PickupMessage"),
                      label: _vm.$t("SeaExport.ActualPickUpTime")
                    }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "13",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.actualPickUpTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "actualPickUpTime", $$v)
                        },
                        expression: "form.actualPickUpTime"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section form-column" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  "label-width": "110px",
                  "label-position": "right",
                  disabled: _vm.readonly
                }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.PODDeliveryInformation")))
                ]),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      title: _vm.$t("SeaExport.DeliveryToWarehouseMessage"),
                      label: _vm.$t(
                        "SeaExport.EstimatedDeliveryToWarehouseTime"
                      )
                    }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "14",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedDeliveryToWarehouseTime,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "estimatedDeliveryToWarehouseTime",
                            $$v
                          )
                        },
                        expression: "form.estimatedDeliveryToWarehouseTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      title: _vm.$t("SeaExport.DeliveryToWarehouseMessage"),
                      label: _vm.$t("SeaExport.ActualDeliveryToWarehouseTime")
                    }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "15",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.deliveryTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "deliveryTime", $$v)
                        },
                        expression: "form.deliveryTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      title: _vm.$t(
                        "SeaExport.EstimatedDeliveryToCustomersWarehouseMessage"
                      ),
                      label: _vm.$t(
                        "SeaExport.EstimatedDeliveryToCustomersWarehouseTime"
                      )
                    }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "16",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.destPortDeliveryTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "destPortDeliveryTime", $$v)
                        },
                        expression: "form.destPortDeliveryTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      title: _vm.$t(
                        "SeaExport.ActualDeliveryToCustomersWarehouseMessage"
                      ),
                      label: _vm.$t(
                        "SeaExport.ActualDeliveryToCustomersWarehouseTime"
                      )
                    }
                  },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "17",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.deliveryCompletionDate,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "deliveryCompletionDate", $$v)
                        },
                        expression: "form.deliveryCompletionDate"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.EstimatedReturnTime") } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "20",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.estimatedReturnTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "estimatedReturnTime", $$v)
                        },
                        expression: "form.estimatedReturnTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.ActualReturnTime") } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        no: "21",
                        type: "datetime",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        format: "yyyy-MM-dd HH:mm"
                      },
                      model: {
                        value: _vm.form.destPortReturnTime,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "destPortReturnTime", $$v)
                        },
                        expression: "form.destPortReturnTime"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }